<template>
  <div>
    <MemberTitle member_title="報名紀錄" member_eng_title="Registration Record" />
    <transition name="fade">
      <div class="loadingMask" v-if="loadingMask"><div><i class="fa fa-spinner fa-pulse"></i></div></div>
    </transition>
    <div class="ticket_box">
      <div class="exhibit_ticket" v-for="(ticket, index) in exhibitList" :key="index">
        <div class="exhibit_ticket_title">
          <div>
            <a :href="ticket.exhibit_data.website_url" target="_blank">
              <img :src="ticket.exhibit_data.website_fb_image_url || ticket.exhibit_data.website_image_url" :alt="ticket.exhibit_data.exhibit_name + '.jpg'" />
            </a>
          </div>
          <div class="exhibit_ticket_info">
            <!-- 展覽名稱 -->
            <div>
              <h3>{{ticket.exhibit_data.exhibit_name}}</h3>
            </div>
            <hr />
            <!-- 展覽資訊 -->
            <div>
              <ul>
                <li>日期: {{ticket.exhibit_data.exhibit_date}}</li>
                <li>時間: {{ticket.exhibit_data.exhibit_hours}}</li>
                <li>地點: {{ticket.exhibit_data.exhibit_location}}</li>
              </ul>
            </div>
            <div>
              <p>※各活動規定及辦法以展覽官網說明為主。</p>
            </div>
          </div>
        </div>
        <div class="exhibit_ticket_content">
          <ul class="checkinList">
            <li class="title">
              <ul>
                <li :class="title.cls" v-for="(title, index) in ticket_title" :key="index">{{title.title}}</li>
              </ul>
            </li>
            <li v-for="(i, index) in ticket.ticketlist" :key="index">
              <ul>
                <li>{{i.create_at}}</li>
                <li class="name">
                  <span>{{i.ticket_name}}</span>
                  <span v-if="i.item">({{i.item.live_date}} {{i.item.live_start_time.substr(0, 5)}} ~ {{i.item.live_end_time.substr(0, 5)}})</span>
                </li>
                <li>
                  <span v-if="i.checkin_status==false">未兌換</span>
                  <span v-else style="color:red;">已兌換</span>
                </li>
                <li class="ticket">
                  <span v-if="!i.isOpen && i.ticket_vendor_checkin == 0">本人身分證件及活動相關證明</span>
                  <a v-if="i.isOpen" @click.prevent="toggleModal(i.ticket_id)"><img src="@/assets/check_qr_code.png" alt=""></a>
                  <PopInfo v-if="i.isOpen" :modalFlag="modalFlag" :exhibit_info="ticket.exhibit_data" :freeTicket="i" @closeModal="toggleModal"/>
                  <button class="partner_btn" v-if="i.ticket_vendor_checkin == 1" @click="partner_checkin(i.approve_code)">廠商核銷</button>
                </li>
                <li>
                  <span>{{ typeof(i.memo)!=='undefined'?i.memo:"" }}</span>
                </li>
                <li class="cancel">
                  <button class="del_btn" @click="ticket_delete(i.ticket_id)">取消</button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="notHasList" v-if="ticket_data == ''">
			您目前沒有任何報名記錄喔!
    </div>
    <BaseFooter />
  </div>
</template>
<script>
import MemberTitle from "@/components/member/MemberTitle";
import PopInfo from '@/components/member/PopInfo'
import BaseFooter from "@/components/base/BaseFooter";
export default {
  name: "MemberTicket",
  components: {
    MemberTitle: MemberTitle,
    PopInfo: PopInfo,
    BaseFooter: BaseFooter
  },
  data() {
    return {
      token: this.$cookies.get('member').token,
      rows: 50,
      ticket_title: [
        {title: '報名時間', cls: ''}, {title: '活動名稱', cls: 'name'}, {title: '兌換狀況', cls: ''},
        {title: '報到憑證', cls: 'ticket'}, {title: '備註', cls: ''}, {title: '取消', cls: 'cancel'},
      ],
      ticket_data: {},
      ticket_list: {},
      exhibitList: [],
      modalFlag: '',
      loadingMask: true,
    };
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/"
    }
  },
  created() {
    this.ticketList()
  },
  methods: {
    ticketList() {
      var vm = this;
      var ticket_api = vm.API + "api/member/ticket?token=" + vm.token + "&rows=" + vm.rows
      vm.loadingMask = true
      vm.axios.get(ticket_api).then(res => {
          // console.log(res.data.data.data)
          if (res.data.status == 200) {
            // 取得索票資料
            vm.ticket_data = res.data.data.data
            var data = res.data.data.data
            var ticket_qrcode_skip = []

            for (var i in data) {
              data[i].isOpen = ticket_qrcode_skip.indexOf(parseInt(data[i].ticket_id)) == -1 ? true : false
              // 只有門票才顯示QRCode
              if (parseInt(data[i].ticket_kind_id) != 1 || parseInt(data[i].send_qrcode) != 1) {
                data[i].isOpen = false
              }
              data[i].checkin_status = data[i].checkin.logs.length == 0 ? false : true
              vm.checkList(data[i])
            }
            vm.loadingMask = false
          } else {
            alert("錯誤碼: " + res.data.status + res.data.message)
            if (res.data.status == 602 || res.data.status == 603) {
              vm.$cookies.remove('member')
              vm.$router.push("/")
            }
            vm.loadingMask = false
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    checkList(exhi_data) {
      var vm = this
      for (var v in vm.exhibitList) {
        if (vm.exhibitList[v].exhibit_data.exhibit_id == exhi_data.exhibit_id) {
          return (function() {
            vm.exhibitList[v].ticketlist.push(exhi_data)
          })()
        }
      }
      return (function() {
        vm.exhibitList.push({
          exhibit_data: vm.data_format(exhi_data),
          ticketlist: [exhi_data]
        })
      })()
    },
    ch_calcDay(date){
      var ch_day
      switch (date.getDay()){
        case 0:
          ch_day = '日'
          break
        case 1:
          ch_day = '一'
          break
        case 2:
          ch_day = '二'
          break
        case 3:
          ch_day = '三' 
          break
        case 4:
          ch_day = '四' 
          break
        case 5:
          ch_day = '五' 
          break
        case 6:
          ch_day = '六' 
          break
      }
      return ch_day
    },
    data_format(data) {
      var start_d = new Date(data.exhibit_start_date)
      var start_m = start_d.getMonth() + 1 < 10 ? "0" + String(start_d.getMonth() + 1) : String(start_d.getMonth() + 1)
      var start_day = start_d.getDate() < 10 ? "0" + String(start_d.getDate()) : String(start_d.getDate())
      var end_d = new Date(data.exhibit_end_date)
      var end_m = end_d.getMonth() + 1 < 10 ? "0" + String(end_d.getMonth() + 1) : String(end_d.getMonth() + 1)
      var end_day = end_d.getDate() < 10 ? "0" + String(end_d.getDate()) : String(end_d.getDate())
      // 判斷星期幾
      var ch_start_day = '(' + this.ch_calcDay(start_d) + ')'
      var ch_end_day = '(' + this.ch_calcDay(end_d) + ')'

      // 開展日期y.m.d
      var start_date = start_m + "/" + start_day + ch_start_day
      // 展期最後一天y.m.d
      var end_date = ""
      if (start_d.getFullYear() != end_d.getFullYear()) {
        end_date += end_d.getFullYear() + "/"
      }
      end_date += end_m + "/" + end_day + ch_end_day
      // 展期時間
      var exhibit_date = start_date + "~" + end_date
      var reData = {
        exhibit_date: exhibit_date,
        exhibit_name: data.exhibit_short,
        exhibit_location: data.exhibit_location ? data.exhibit_location.name : "",
        exhibit_hours: data.exhibit_hours,
        website_fb_image: data.website_fb_image,
        website_fb_image_url: data.website_fb_image_url,
        website_image_url: data.website_image_url,
        website_url: (data.website_url == '' ? 'https://demo.top-link.com.tw/' + data.exhibit_id : data.website_url),
        exhibit_id: data.exhibit_id,
        isOpen: data.isOpen // 有 QR code 的才會開
      }
      return reData
    },
    ticket_delete(ticket_id){
      var vm = this
      var delete_api = vm.API + 'api/member/sign_delete'
      var data = new FormData()
      data.set('token', vm.token)
      data.set('ticket_id', ticket_id)
      if(confirm("取消報名後無法再恢復此報名活動，如消費者須參加活動必須重新報名")){
        vm.axios.post(delete_api, data).then(res => {
          // console.log(res)
          if(res.data.status == 823){
            alert(res.data.message)
            vm.$router.go(0)
          
          }
          else {
            if (res.data.status == 602 || res.data.status == 603) {
              vm.$cookies.remove('member')
              vm.$router.push("/")
            } else {
              alert('錯誤碼: ' +res.data.status + res.data.message)
            }
            vm.loading = false
          }
        })
        .catch(function(error) {
          console.log(error)
        })
      }
    },
    toggleModal(index){
      this.modalFlag = index
    },
    // 廠商核銷
    partner_checkin(approve_code){
      var vm = this
      var data = new FormData()
      var partner_checkin_api = vm.API + "api/member/vendor_checkin"
      data.set('token', vm.token)
      data.set('approve_code', approve_code)
      if(confirm("確定是否核銷，若非工作人員請勿自行點擊")){
        vm.axios.post(partner_checkin_api, data).then((res) => {
          if(res.data.status == 200){
            alert(res.data.message)
            vm.$router.go(0)
          } else {
            if (res.data.status == 602 || res.data.status == 603) {
              vm.$cookies.remove('member')
              vm.$router.push("/")
            } else {
              alert('錯誤碼: ' +res.data.status + res.data.message)
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
      }
      
    }
  }
}
</script>

<style>
/* transition fade */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Loading Mask */
.loadingMask{
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: calc(100%);
  height: 100vh;
  z-index: 99999;
}

.loadingMask div{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 6rem;
  color: #d3d3d3;
}

.notHasList{
  width: 95%;
  max-width: 500px;
  margin: 40px auto;
  padding: 40px 0;
  text-align: center;
  background: rgba(255, 255, 255, 0.31);
  border: 2px dotted #000;
  font-size: 2rem;
}
.ticket_box ul {
  padding: 0;
  margin: 0;
}
.exhibit_ticket {
  width: 90%;
  max-width: 100%;
  margin: 60px auto;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  overflow: hidden;
}
.exhibit_ticket_title > div:nth-child(1) {
  width: 250px;
  margin-right: 15px;
}
.exhibit_ticket_title {
  display: flex;
  background-color: #e6e7e8;
  padding: 20px;
  padding-bottom: 0;
}
.exhibit_ticket_info { width: 80%; }
.exhibit_ticket_info div:nth-of-type(1) h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 10px 0;
}
.exhibit_ticket_info div:nth-of-type(2) ul { display: flex; }
.exhibit_ticket_info div:nth-of-type(2) ul li {
  width: calc(100% / 3);
  font-size: 18px;
}
.exhibit_ticket_info div:nth-of-type(3) p {
  color: red;
  font-weight: 600;
  font-size: 17px;
}
/* 索票內容 */
/* 全域 */
.exhibit_ticket_content .checkinList {
  border-radius: 0 0 20px 20px;
  overflow: hidden;
}
.exhibit_ticket_content .checkinList > li {
  background-color: #ebebeb;
  margin: 0;
  box-shadow: 1px 1px 13px rgba(0, 0, 0, 0.3);
  max-width: 100%;
  font-size: 18px;
  border-right: 1px solid #a19e9e;
}
.exhibit_ticket_content .checkinList .title {
  background-color: #4a5579;
  color: #ffffff;
  letter-spacing: 6px;
  font-size: 1.2rem;
}
.exhibit_ticket_content .checkinList .title .name { text-align: center; }
.exhibit_ticket_content .checkinList .name span {
  /* padding-left: 10px; */
  line-height: 1.5;
  display: block;
}
.exhibit_ticket_content>ul>li>ul { display: flex; }
.exhibit_ticket_content>ul>li>ul>li {
  width: 17%;
  min-height: 80px;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.exhibit_ticket_content>ul>li>ul>li:not(:last-of-type) { border-right: 1px solid #a19e9e; }
.exhibit_ticket_content ul li ul li.name {
  width: 38%;
  text-align: left;
  padding-left: 5px;
}
.exhibit_ticket_content ul li ul li.ticket { width: 27%; align-items: center;}
.exhibit_ticket_content ul li ul li.cancel { width: 70px; }
.exhibit_ticket_content ul li ul li.cancel button.del_btn{
  margin: auto;
  padding: .375rem .25rem;
  font-size: 1rem;
  line-height: 1.4;
  border-radius: .25rem;
  border: 0;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Microsoft JhengHei';
  background-color: #313131;
  color: #fff;
}
.exhibit_ticket_content ul li ul li.ticket>a{ width: fit-content; cursor: pointer;}
.exhibit_ticket_content ul li ul li.ticket .partner_btn {
  font-size: 1rem; 
  font-weight: 400;
  line-height: 1.5;
  background-color: #093f7a;
  border-color: #007bff;
  color: #fff;
  padding: .375rem .25rem; 
  border-radius: .25rem; 
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Microsoft JhengHei';

  }
.exhibit_ticket_content ul li ul li.ticket .partner_btn:hover{ color: #fff; background-color: #0069d9; border-color: #0062cc;}
.exhibit_ticket_content ul li ul li.cancel button.del_btn:hover{
  background-color: #fff;
  color: #313131;
}
.exhibit_ticket_content ul li ul li.name span:nth-of-type(2) {
  font-size: 0.9rem;
  color: rgba(2, 2, 2, 0.5);
}
@media (max-width: 1300px) {
  .exhibit_ticket{width: 97%;}

}
@media (max-width: 1170px) {
  .exhibit_ticket_info{width: 100%;}
  .exhibit_ticket_title > div:nth-child(1){display: none;}
}
@media (max-width: 768px) {
  .exhibit_ticket_info div:nth-of-type(1) h3 { font-size: 1.4rem;}
  .exhibit_ticket_info div:nth-of-type(2) ul{flex-direction: column}
  .exhibit_ticket_info div:nth-of-type(2) ul li{width: 100%; line-height: 2;}
  
  .exhibit_ticket_content>ul>li>ul>li:nth-of-type(1),
  .exhibit_ticket_content>ul>li>ul>li:nth-of-type(3){ display: none;}
  .exhibit_ticket_content ul li ul li.name{ width: 58%}
  .exhibit_ticket_content ul li ul li.ticket{width: 40%;}
  .exhibit_ticket_content ul li ul li.cancel{ width: 50px}
  .exhibit_ticket_content .checkinList > li,
  .exhibit_ticket_content .checkinList .title{font-size: 16px; letter-spacing:0}

  .notHasList{ font-size: 1.6rem;}
}
</style>